import { NgModule } from '@angular/core';
import { TtpSearchComponent } from '@app/pcs/shared/ttp-search/ttp-search.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    TtpSearchComponent
  ],
  exports: [
    TtpSearchComponent
  ]
})
export class TtpSearchModule {
}
